import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { StaticInput } from '@framework/form/inputs/static/StaticInput.tsx';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem.tsx';
import { type IPaymentRowWidget } from '../IPaymentRowWidget.ts';
import { PaymentRowLogic } from '../PaymentRowLogic.ts';

export interface IPaymentRowReportFieldProps {
  readonly: boolean;
  name: string;
  label: string;
  value: number | null;
  widget: IPaymentRowWidget;
}

/**
 * Renderizza e valorizza nel form i campi di riepilogo di una riga di pagamento
 * (imponibile, IVA, totale).
 * È fondamentale per poter inserire nel form i valori calcolati dalla logica di business.
 */
export function PaymentRowReportField(props: IPaymentRowReportFieldProps) {
  const { readonly, label, value, name, widget } = props;

  return (
    <ConfigFormItem
      name={name}
      label={label}
      readonly={readonly}
      style={{ maxWidth: 140 }}
      layout={{ removeMargin: true }}
      widget={widget}
    >
      {/* Mettiamo un componente di placeholder così da mostrare qualcosa all'utente */}
      {value == null && <StaticInput value={'- €'} removeBorder />}
      <ComputedStaticTextInput
        name={name}
        renderFormat={v => PaymentRowLogic.formatCurrency(v)}
        removeBorder
        hidden={value == null}
      />
    </ConfigFormItem>
  );
}
